export const federationIdService = {
    methods: {
        federationId() {
            return this.$store.state.FederationId;
        }
    }
};